/**
 * Product specific functions
 */

import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';

/**
 * Generate a fake internet product
 * @param index
 * @returns object
 */
export function generateFakeProduct(index) {
    let logoSlug = 'nle';

    if (index === 0) {
        logoSlug = 'oxxio';
    } else if (index === 1) {
        logoSlug = 'essent';
    }

    return {
        rank: index,
        base_id: index,
        base_name: 'Voorbeeld contract',
        provider_logo: `https://energievergelijker.keuze.nl/logo/provider/${logoSlug}`,
        tariff_type: 'fixed',
        provider: 'oxxio',
        provider_name: 'Oxxio',
        contract_duration: 12,
        contract_duration_text: '1 jaar',
        month_price: 115.44,
        month_price_without_discount: 131.27,
        year_price: 1385.24,
        year_price_without_discount: 1575.24,
        contract_price: 1385.24,
        contract_price_without_discount: 1575.24,
        compare_price: 115.43641666667,
        electricity_included: true,
        electricity_green: 'compensated',
        electricity_source: [
            {
                type: 'WIND',
                label: 'Windkracht',
                percentage: 100,
            },
        ],
        gas_included: true,
        gas_green: false,
        total_discount: 190,
        offer_type: 'discount',
        offer_text_long: null,
        offer_text_short: null,
        offer_new_customers_only: true,
        offer_existing_customers_only: false,
        discount_text: '€ 190,00 korting',
        contract_ends_at_month_end: false,
        available_without_gas: false,
        electricity_feedin_bonus_name: null,
        price_calculation: {
            electricity_base: 71.87,
            electricity_double_meter: false,
            electricity_generation: false,
            electricity_surplus: false,
            electricity_consumption: 3500,
            electricity_consumption_off_peak: null,
            electricity_consumption_total: 3500,
            electricity_consumption_settling_normal: null,
            electricity_consumption_settling_off_peak: null,
            electricity_consumption_settling_total: null,
            electricity_consumption_net_normal: 3500,
            electricity_consumption_net_off_peak: null,
            electricity_consumption_net_total: 3500,
            electricity_generation_surplus: null,
            electricity_unit_price: 0.21012,
            electricity_unit_price_off_peak: null,
            electricity_unit_total: 735.42,
            electricity_unit_settled_total: null,
            electricity_unit_net_total: 735.42,
            electricity_unit_total_off_peak: null,
            electricity_unit_settled_total_off_peak: null,
            electricity_unit_net_total_off_peak: null,
            electricity_surplus_price: null,
            electricity_surplus_tariff: null,
            electricity_surplus_bonus: null,
            electricity_network_costs: 256.68,
            electricity_total: 1063.97,
            electricity_total_with_tax_discount: 536.8,
            gas_region: 4,
            gas_base: 71.87,
            gas_consumption: 1000,
            gas_unit_price: 0.766217,
            gas_unit_total: 766.217,
            gas_network_costs: 200.35,
            gas_total: 1038.437,
            tax_discount: 527.17,
            administration_costs_year: null,
            administration_costs_total: null,
            year_price_without_discount: 1575.24,
            contract_price_without_discount: 1575.24,
            total_discount: 190,
            contract_price: 1385.24,
            distributor_name: 'liander',
        },
        tariffs_with_discount: true,
        show_legacy: false,
        cval: 1,
        legacy_month: null,
        legacy_year: null,
        provider_url: null,
        signup_url: null,
    };
}

export function iconsToSources(originalSources) {
    let sources = sortBy(originalSources, ((o) => 100 - o.percentage));

    sources = filter(sources, ((o) => o.percentage > 0));

    sources = map(sources, (val) => {
        const source = val;

        // Change icon to more appropriate icon:
        switch (source.type) {
        case 'WIND':
            source.icon = 'x-fa-wind-turbine';
            break;
        case 'NATURAL_GAS':
            source.icon = 'x-fa-burn';
            break;
        case 'OIL':
            source.icon = 'x-fa-gas-pump';
            break;
        case 'BIOMASS':
            source.icon = 'x-fa-trees';
            break;
        case 'COAL':
            source.icon = 'x-fa-industry-alt';
            break;
        case 'NUCLEAR':
            source.icon = 'x-fa-radiation-alt';
            break;
        case 'WATER':
            source.icon = 'x-fa-water';
            break;
        case 'SUN':
            source.icon = 'x-fa-sun';
            break;
        default:
            source.icon = 'x-fa-question-circle';
            break;
        }

        return source;
    });

    return sources;
}

export function scoreToLabel(score) {
    if (score >= 8) {
        return '<span class="green-score-label green-score-a">A <span class="green-arrow-right"></span></span>';
    } if (score >= 6 && score < 8) {
        return '<span class="green-score-label green-score-b">B <span class="green-arrow-right"></span></span>';
    }
    return '<span class="green-score-label green-score-c">C <span class="green-arrow-right"></span></span>';
}

export function scoreToLabelText(score) {
    if (score >= 8) {
        return 'A';
    } if (score >= 6 && score < 8) {
        return 'B';
    }
    return 'C';
}
